import { styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomForm = styled('form')(() => {
    return {
        width: '100%',
    };
});

export default forwardRef(({ onSubmit, ...rest }, ref) => {
    return (
        <CustomForm
            ref={ref}
            {...rest}
            noValidate
            onSubmit={(e) => {
                e.preventDefault();
                onSubmit(e);
            }}
        />
    );
});
